export const SEEKER_STORAGE_KEY = "mkssjdppioawkwlJJHH1KJSAS";
